import React, { useState } from "react"
import { ThemeProvider } from "../../context/ThemeContext"
import Header from "../Header/Header"
import Hero from "../Hero/Hero"
import Features from "../Features/Features"
import Benefits from "../Benefits/Benefits"
import Contact from "../Contact/Contact"
import Footer from "../Footer/Footer"
import ScrollToTop from "../ScrollToTop/ScrollToTop"
import "./variables.css"
import "./Landing.css"
import { usePageConfig } from "src/hooks/usePageConfig"


const Landing = () => {
  const [landingElement, setLandingElement] = useState(null)

  usePageConfig({ title: 'Next Generation Trade Platform', viewportScale: 1 })

  // remove any homePagePath
  sessionStorage.removeItem('homePagePath')

  return (
    <ThemeProvider targetElement={landingElement}>
      <div className="nang-landing" ref={setLandingElement}>
        <Header />
        <main>
          <Hero />
          <Features />
          <Benefits />
          <Contact />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </ThemeProvider>
  )
}

export default Landing
